import React, { useEffect, useState } from "react";
import Strings from "@my-dld/assets/strings";
import { CoOccupant } from "@eres/ejari-api/Entity/co_occupants";
import { formatAppDate } from "@my-dld/utils/Utils";
import { EjariApi } from "@eres/ejari-api";
import { showErrorMessage } from "@my-dld/utils/UIUtils";
import { PropertyCoOccupantContractType } from "@eres/ejari-api/api";

interface PProps {
	propertyId: number;
	propertyTypeId: number;
	isFreeHold: boolean;
}

export function PropertyCoOccupants( props: PProps ) {
	let { propertyTypeId, propertyId, isFreeHold } = props;
	const [ occupants, setOccupants ] = useState<CoOccupant[]>( [] );
	useEffect( () => {
		if ( propertyTypeId == null || propertyId == null ) return;
		EjariApi.getCoOccupants( propertyId, PropertyCoOccupantContractType, propertyTypeId, isFreeHold )
		.then( x => {
			setOccupants( x.CoTenants ?? [] );
		} )
		.catch( showErrorMessage );
	}, [ propertyId, propertyTypeId, isFreeHold ] );
	return <CoOccupantList occupants={ occupants } title={ Strings.co_occupant_details }/>;
}

interface Props {
	contractType?: number;
	contractId?: number;
}

export function CoOccupants( props: Props ) {
	let { contractId, contractType } = props;
	const [ occupants, setOccupants ] = useState<CoOccupant[]>( [] );
	useEffect( () => {
		if ( contractId == null || contractType == null ) return;
		EjariApi.getCoOccupants( contractId, contractType )
		.then( x => {
			setOccupants( x.CoTenants ?? [] );
		} )
		.catch( showErrorMessage );
	}, [ contractId, contractType ] );
	return <CoOccupantList occupants={ occupants } title={ Strings.co_occupant_details }/>;
}

function CoOccupantList( props: { occupants: CoOccupant[]; title: string } ) {
	let { occupants } = props;
	if ( occupants.length === 0 ) return null;
	return <>
		<div className="" id="occupantListDetail">
            {/*<div className="section-title justify-content-between">
				<h5>{ Strings.co_occupant_details }</h5>
			</div>*/}
			<table className="table table-bordered table-striped font-size14">
				<COHeader/>
				<tbody>
				{ occupants.map( ( value, index ) =>
					<CORow index={ index } data={ value } key={ index }/> )
				}
				</tbody>
			</table>
		</div>
	</>;
}

export function COHeader( props: React.PropsWithChildren<any> ) {
	return <thead>
	<tr>
		<th style={ { width: 70 } }>{ Strings.sr_no }</th>
		<th>{ Strings.name_english }</th>
		<th>{ Strings.name_arabic }</th>
		<th>{ Strings.emirates_id }</th>
		<th>{ Strings.date_of_birth }</th>
		<th>{ Strings.co_occupant_is_people_of_determination }</th>
		{ props.children }
	</tr>
	</thead>;
}

export function CORow( props: React.PropsWithChildren<{ index: number, data: CoOccupant }> ) {
	let { data, index, children } = props;
	return <tr>
		<td data-label={ Strings.sr_no }>{ index + 1 }</td>
		<td data-label={ Strings.name_english }>{ data.TenantEnglishName }</td>
		<td data-label={ Strings.name_arabic }>{ data.TenantArabicName }</td>
		<td data-label={ Strings.emirates_id }>{ data.Person?.EmiratesId }</td>
		<td data-label={ Strings.date_of_birth }>{ formatAppDate( data.Person?.DOB ) }</td>
		<td data-label={ Strings.co_occupant_is_people_of_determination }>
			{ data.SpecialCase ? Strings.yes : Strings.no }
		</td>
		{ children }
	</tr>;
}

